import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthGuard } from '../../../../core/auth/auth.guard';
import { HeadendSummaryResolve } from '../shared/headend-summary-resolve.service';
import { HeadendIdGuard } from '../shared/headend-id-guard.service';
import { SwapRequestComponent } from './swap-request.component';
import { HeadendSummaryClearGuard } from '../shared/headend-summary-clear.guard';

@NgModule({
	imports: [
		RouterModule.forChild([
			{
				path: 'signals/swap',
				component: SwapRequestComponent,
				canActivate: [AuthGuard, HeadendIdGuard],
				canDeactivate: [HeadendSummaryClearGuard],
				resolve: {
					headendSummary: HeadendSummaryResolve
				}
			}
		])
	],
	exports: [
		RouterModule
	],
	providers: [
		HeadendSummaryResolve,
		HeadendIdGuard,
		HeadendSummaryClearGuard
	]
})

export class SwapRequestRoutingModule {
}